import { Injectable } from '@angular/core';

export const VENDOR_SCRIPTS = [
  'assets/js/modernizr-2.8.3.min.js',
  'assets/js/jquery.min.js',
  'assets/js/bootstrap.min.js',
  'assets/js/rsmenu-main.js',
  'assets/js/jquery.nav.js',
  'assets/js/owl.carousel.min.js',
  'assets/js/slick.min.js',
  'assets/js/isotope.pkgd.min.js',
  'assets/js/imagesloaded.pkgd.min.js',
  'assets/js/wow.min.js',
  'assets/js/skill.bars.jquery.js',
  'assets/js/jquery.counterup.min.js',
  'assets/js/waypoints.min.js',
  'assets/js/jquery.mb.YTPlayer.min.js',
  'assets/js/jquery.magnific-popup.min.js',
  'assets/js/tilt.jquery.min.js',
  'assets/js/plugins.js',
  'assets/js/contact.form.js',
  'assets/js/main.js'
];

@Injectable({
  providedIn: 'root'
})
export class ScriptLoaderService {
  private readonly loaded = new Map<string, Promise<void>>();

  /**
   * Ensures the given scripts are loaded in order. Subsequent calls reuse already loaded scripts.
   */
  loadSequential(...sources: string[]): Promise<void> {
    return sources.reduce((prev, src) => prev.then(() => this.loadScript(src)), Promise.resolve());
  }

  private loadScript(src: string): Promise<void> {
    const resolvedSrc = this.resolveScriptUrl(src);
    if (this.loaded.has(resolvedSrc)) {
      return this.loaded.get(resolvedSrc)!;
    }

    const promise = new Promise<void>((resolve, reject) => {
      if (typeof document === 'undefined') {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = resolvedSrc;
      script.type = 'text/javascript';
      script.async = false;
      script.defer = false;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load script: ${resolvedSrc}`));
      document.body.appendChild(script);
    });

    this.loaded.set(resolvedSrc, promise);
    return promise;
  }

  private resolveScriptUrl(src: string): string {
    if (typeof document === 'undefined') {
      return src;
    }

    return new URL(src, document.baseURI).toString();
  }
}
